import React from 'react';

/**
 * The handoff icon set — rule 1: no icon library, no emoji, no new glyphs.
 * These are the exact inline SVGs from the prototypes: 2px stroke,
 * stroke-linecap="square", stroke-linejoin="miter", currentColor.
 */
const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'square',
  strokeLinejoin: 'miter',
};

export const SearchIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" {...base}>
    <circle cx="7" cy="7" r="4.5" /><path d="M10.5 10.5L14 14" />
  </svg>
);

export const MessageIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M3 4h14v10H8l-4 3v-3H3z" />
  </svg>
);

export const BellIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M5 8a5 5 0 0110 0v5l2 2H3l2-2z" /><path d="M8 17h4" />
  </svg>
);

export const ChevronDownIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" {...base}>
    <path d="M2 4l4 4 4-4" />
  </svg>
);

export const PlusIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
    <path d="M5 12h14M12 5v14" />
  </svg>
);

export const ShareIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M10 13V3" /><path d="M6 6l4-3 4 3" /><path d="M4 12v5h12v-5" />
  </svg>
);

// The app's long-standing beacon mark, not the handoff's antenna arcs — owner
// call (Aug 2026), kept identical everywhere a signal is marked.
export const SignalIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="7" r="2" /><path d="M12 9V21" />
    <path d="M8.4 3.6a5.5 5.5 0 0 0 0 6.8" /><path d="M15.6 3.6a5.5 5.5 0 0 1 0 6.8" />
  </svg>
);

export const CalendarIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <rect x="3" y="4" width="14" height="13" /><path d="M3 8h14M7 2v4M13 2v4" />
  </svg>
);

export const TicketIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M2 6h16v3a2 2 0 0 0 0 4v3H2v-3a2 2 0 0 0 0-4z" /><path d="M12 6v10" />
  </svg>
);

export const TagIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M10 2H2v8l8 8 8-8z" /><path d="M6 6h.01" />
  </svg>
);

export const MapPinIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M10 18s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10z" /><circle cx="10" cy="8" r="2" />
  </svg>
);

export const CloseIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" {...base}>
    <path d="M4 4l12 12M16 4L4 16" />
  </svg>
);
